import { render } from "./DKELogo.vue?vue&type=template&id=4ef5de88"
import script from "./DKELogo.vue?vue&type=script&lang=js"
export * from "./DKELogo.vue?vue&type=script&lang=js"

import "./DKELogo.vue?vue&type=style&index=0&id=4ef5de88&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__